const guide = {
  moreInfo: "More Info",
  example: "Example",
  askAI: "Ask AI",
  editHint: "Right-click to edit",
  supports: "Supported properties",
  colors: "Colors",
  typography: "Typography",
  text: "Text",
} as const;
export default guide;
